import { render, staticRenderFns } from "./contact-requests.vue?vue&type=template&id=76ed55c0&lang=pug&"
import script from "./contact-requests.vue?vue&type=script&lang=js&"
export * from "./contact-requests.vue?vue&type=script&lang=js&"
import style0 from "./contact-requests.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports